import React, { useState } from 'react';
import { 
  Card, 
  Grid 
} from '@mui/material';
import { EnhancedCardContent } from '../card/EnhancedCardContent';
import { EntryPointModal } from '../propertyCardModal/EntryPointModal';

export const EntryPoints = (props) => {
  const [showModal, setShowModal] = useState(false);
  const data = props.property.lastSurvey.entrypointSet;

  const cardInfo =
  {
    id: "entry-points",
    imageSource: "/Entry points.png",
    summaryNumber: props.property.lastSurvey.entrypointSet.length,
    title: "Entry Points",
    subtitle: data?.filter((entryPoint) =>  entryPoint.is_over_7_meters_from_another_entry === "Yes").length + " Diverse",
  }
  
  // Press the button to show form
  const handleClick = () => {
      setShowModal(true);
  }
    
  return (
    <Grid item>
      {(props.property.lastSurvey.entrypointSet.length === 0) ?
        <></> :
        showModal && <EntryPointModal setShowModal={setShowModal} data={data} />
      }
      <Card sx={props.shadowStyle} onClick={handleClick}>
        <EnhancedCardContent item={cardInfo} />
      </Card>
    </Grid>
  )
}
